import { useMemo, useState } from "react";
import Cookies from "js-cookie";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import CartItem from "../../components/Cart/CartItem";
import LoadingScreen from "../../components/loading/LoadingScreen";
import CartTotal from "../../components/Cart/CartTotal";
import CartBulkEditing from "../../components/Cart/CartBulkEditing";
import { useFetchData, usePostApiRequest } from "../../helpers/api";
import { handleGlobalInputChange } from "../../helpers/functions";
import toast from "react-hot-toast";
import "../../assets/css/cart.css";
import { useParams } from "react-router-dom";

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const customerId = customerData?.Id ? customerData.Id : null;
const customerCode = customerData?.Code ? customerData.Code : null;

const canOrderPlace = true;
const weightMapping = {
  "18K": 1,
  "14K": 0.875,
  "10K": 0.76,
};

const Cart = () => {
  const partnerCustomerCode = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isBulkEditing, setIsEditing] = useState(false);

  const [bulkEditValues, setBulkEditValues] = useState({
    carat: "14K",
    clarity: "YW",
  });
  const { data: customerCartData, isLoading: isLoadingCart } = useFetchData(
    "cartData",
    "/Customer/GetCart",
    { CustomerId: customerId, CustomerCode: customerCode, PartnerCustomerCode: partnerCustomerCode.id },
    null,
    { enabled: !!customerId }
  );

  const postApiRequest = usePostApiRequest();
  console.log("cart items :", customerCartData);

  const data = useMemo(() => customerCartData?.Data || [], [customerCartData]);

  const handleInputChange = (e) =>
    handleGlobalInputChange(e, setBulkEditValues);

  const handleSelectAll = (isChecked) => {
    setSelectedItems(isChecked ? data : []);
  };

  const handleItemSelection = (cartItem, isChecked) => {
    setSelectedItems((prev) =>
      isChecked
        ? [...prev, cartItem]
        : prev.filter((item) => item.ProductId !== cartItem.ProductId)
    );
  };

  const handleBulkUpdate = async () => {
    if (!selectedItems.length) {
      toast.error("No items selected");
      return;
    }

    setIsLoading(true);
    const updatedItems = selectedItems.map((item) => {
      const newWeight =
        (item.Weight / weightMapping[item.Carat]) *
        weightMapping[bulkEditValues.carat];

      return {
        Id: item.Id,
        CustomerId: customerId,
        Carat: bulkEditValues.carat,
        Color: bulkEditValues.clarity,
        Weight: newWeight,
      };
    });

    try {
      await postApiRequest({
        url: "/Customer/CartBulkEdit",
        method: "POST",
        data: updatedItems,
        queryKey: ["cartData"],
      });
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const totalCartWeight = data.reduce(
    (sum, item) => sum + item.Weight * item.Quantity,
    0
  );
  const totalCartCarat = data.reduce((sum, item) => {
    return sum + item.DiamondWt * item.Quantity;
  }, 0);

  return (
    <>
      <SEO titleTemplate="Cart" description="Cart page" />
      <LayoutTwo>
        {isLoadingCart ? (
          <LoadingScreen />
        ) : (
          <div className="cart-main-area pt-40 pb-60">
            <div className="container">
              {data && data.length > 0 ? (
                <div className="row cart_con">
                  <div className="col-8">
                    <CartBulkEditing
                      isBulkEditing={isBulkEditing}
                      bulkEditValues={bulkEditValues}
                      handleInputChange={handleInputChange}
                      handleBulkUpdate={handleBulkUpdate}
                      setIsEditing={setIsEditing}
                      selectedItems={selectedItems}
                      handleSelectAll={handleSelectAll}
                      customerCartDataLength={data.length}
                    />
                    <div className="table-content table-responsive cart-table-content">
                      {data.map((cartItem, index) => {
                        return (
                          <CartItem
                            key={index}
                            handleItemSelection={handleItemSelection}
                            selectedItems={selectedItems}
                            cartItem={cartItem}
                            isBulkEditing={isBulkEditing}
                            customerId={customerId}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                          />
                        );
                      })}
                    </div>
                  </div>
                  <CartTotal
                    canOrderPlace={canOrderPlace}
                    totalCartWeight={totalCartWeight}
                    totalCartCarat={totalCartCarat}
                    customerCode={customerCode}
                  />
                </div>
              ) : (
                <div className="row">
                  <div className="col-lg-12">
                    <div className="item-empty-area text-center">
                      <div className="item-empty-area__icon mb-30">
                        <i className="pe-7s-cart"></i>
                      </div>
                      <div className="item-empty-area__text">
                        No items found in cart
                        {/* <br />
                        <Link to="/shop">Shop Now</Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </LayoutTwo>
    </>
  );
};

export default Cart;
